import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
export default function (app) {
  app.component("VueDatePicker", VueDatePicker);
}
